<template>
  <div class="min-vh-100 d-flex">
    <b-container class="align-self-center">
      <b-row>
        <b-col>
          <div class="bg-dark shadow text-light overflow-hidden">
            <div class="p-5 pattern-1">
              <h1 class="text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="37"
                  class="mr-1"
                  viewBox="0 0 352 653"
                  role="img"
                  focusable="false"
                >
                  <title>{{ brand }}</title>
                  <path
                    fill="#56A2CE"
                    d="M351.17 147.16C351.17 149.26 351.17 151.35 351.17 153.45C351.17 205.46 350.86 257.48 351.34 309.49C351.5 326.93 344.76 340.22 329.98 348.22C314.01 356.86 297.12 363.91 280.38 371.06C195.12 407.47 109.78 443.69 24.47 479.97C22.85 480.65 21.23 481.34 19.56 481.88C9.17 485.28 1.45 480.06 0.86 469.26C0.78 467.95 0.82 466.63 0.82 465.31C0.82 422.51 0.83 379.72 0.81 336.92C0.81 320.43 8.48 308.91 23.59 302.49C118.83 262.05 214.1 221.68 309.36 181.28C312.6 179.91 315.85 178.55 318.99 176.98C332.55 170.24 344.8 162.1 351.17 147.16Z"
                  />
                  <path
                    fill="#56A2CE"
                    d="M122.87 223.81C88.56 209.3 54.21 195.2 20.26 180.2C7.67 174.64 0.95 163.62 0.89 149.66C0.68 105.33 0.77 60.99 0.83 16.65C0.85 2.46 9.44 -3.04 22.75 2.62C89.06 30.81 155.35 59.06 221.66 87.28C243.69 96.66 265.82 105.83 287.7 115.55C293.61 118.18 299.32 121.88 304.14 126.18C309.98 131.4 310.18 138.24 304.44 143.58C299.23 148.42 293.13 152.89 286.62 155.64C232.37 178.51 177.94 200.95 122.87 223.81Z"
                  />
                  <path
                    fill="#56A2CE"
                    d="M229.19 428.95C263.5 443.46 297.84 457.56 331.77 472.56C344.36 478.12 351.08 489.14 351.14 503.1C351.34 547.43 351.25 591.77 351.2 636.11C351.18 650.3 342.59 655.8 329.29 650.14C263 621.95 196.73 593.7 130.45 565.48C108.42 556.1 86.3 546.94 64.42 537.21C58.51 534.59 52.81 530.88 47.99 526.58C42.15 521.36 41.95 514.52 47.69 509.18C52.89 504.34 59 499.87 65.5 497.12C119.73 474.25 174.15 451.81 229.19 428.95Z"
                  />
                </svg>
                {{ brand }}
              </h1>
              <!-- <h1>Go. Play.</h1>
              <p class="mb-5">Would you like to know more?</p> -->
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      // title: 'ZergLabs',
      meta: [
        { vmid: 'description', name: 'description', content: 'We build the Internet.' }
      ]
    },
    data() {
      return {
        brand: process.env.VUE_APP_CLIENT_NAME
      }
    }
  }
</script>
